import { render, staticRenderFns } from "./BlockArticles.vue?vue&type=template&id=65d2d471&scoped=true&"
import script from "./BlockArticles.vue?vue&type=script&lang=js&"
export * from "./BlockArticles.vue?vue&type=script&lang=js&"
import style0 from "./BlockArticles.vue?vue&type=style&index=0&id=65d2d471&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2d471",
  null
  
)

export default component.exports